import { StusdsWelcomeDialogContainer } from './StusdsWelcomeDialogContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface StusdsWelcomeDialogProps extends CommonDialogProps {
  onConfirm: () => void
  chainId: number
}

function StusdsWelcomeDialog({ open, ...props }: StusdsWelcomeDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent spacing="none" showCloseButton={false} preventAutoFocus>
        <StusdsWelcomeDialogContainer {...props} />
      </DialogContent>
    </Dialog>
  )
}

const dialogConfig = {
  options: {
    closeOnAccountChange: false,
  },
  element: StusdsWelcomeDialog,
  name: 'StusdsWelcomeDialog',
} satisfies DialogConfig<StusdsWelcomeDialogProps>

export const stusdsWelcomeDialogConfig: DialogConfig<StusdsWelcomeDialogProps> = dialogConfig
